import { render, staticRenderFns } from "./IndustryInformation.vue?vue&type=template&id=cb108e08&scoped=true&"
import script from "./IndustryInformation.vue?vue&type=script&lang=js&"
export * from "./IndustryInformation.vue?vue&type=script&lang=js&"
import style0 from "./IndustryInformation.vue?vue&type=style&index=0&id=cb108e08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb108e08",
  null
  
)

export default component.exports